import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps): React.ReactElement | null => {
  const location = useLocation();
  const isLoggedIn = sessionStorage.getItem('userLoggedIn') === '1';

  if (!isLoggedIn) {
    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return children as React.ReactElement;
};

export default PrivateRoute;